"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The GlobalNotification model module.
 * @module model/GlobalNotification
 * @version 0.0.1
 */
class GlobalNotification {
  /**
   * Constructs a new <code>GlobalNotification</code>.
   * @alias module:model/GlobalNotification
   * @param nutzerId {String} 
   * @param neuigkeitenKfv {Boolean} 
   * @param neuigkeitenKjf {Boolean} 
   * @param fortbildungKfv {Boolean} 
   * @param fortbildungKjf {Boolean} 
   * @param stellenanzeige {Boolean} 
   * @param id {Number} 
   */
  constructor(nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige, id) {
    GlobalNotification.initialize(this, nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige, id);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, nutzerId, neuigkeitenKfv, neuigkeitenKjf, fortbildungKfv, fortbildungKjf, stellenanzeige, id) {
    obj['nutzer_id'] = nutzerId;
    obj['neuigkeiten_kfv'] = neuigkeitenKfv;
    obj['neuigkeiten_kjf'] = neuigkeitenKjf;
    obj['fortbildung_kfv'] = fortbildungKfv;
    obj['fortbildung_kjf'] = fortbildungKjf;
    obj['stellenanzeige'] = stellenanzeige;
    obj['id'] = id;
  }

  /**
   * Constructs a <code>GlobalNotification</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GlobalNotification} obj Optional instance to populate.
   * @return {module:model/GlobalNotification} The populated <code>GlobalNotification</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GlobalNotification();
      if (data.hasOwnProperty('nutzer_id')) {
        obj['nutzer_id'] = _ApiClient.default.convertToType(data['nutzer_id'], 'String');
      }
      if (data.hasOwnProperty('neuigkeiten_kfv')) {
        obj['neuigkeiten_kfv'] = _ApiClient.default.convertToType(data['neuigkeiten_kfv'], 'Boolean');
      }
      if (data.hasOwnProperty('neuigkeiten_kjf')) {
        obj['neuigkeiten_kjf'] = _ApiClient.default.convertToType(data['neuigkeiten_kjf'], 'Boolean');
      }
      if (data.hasOwnProperty('fortbildung_kfv')) {
        obj['fortbildung_kfv'] = _ApiClient.default.convertToType(data['fortbildung_kfv'], 'Boolean');
      }
      if (data.hasOwnProperty('fortbildung_kjf')) {
        obj['fortbildung_kjf'] = _ApiClient.default.convertToType(data['fortbildung_kjf'], 'Boolean');
      }
      if (data.hasOwnProperty('stellenanzeige')) {
        obj['stellenanzeige'] = _ApiClient.default.convertToType(data['stellenanzeige'], 'Boolean');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>GlobalNotification</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GlobalNotification</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of GlobalNotification.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['nutzer_id'] && !(typeof data['nutzer_id'] === 'string' || data['nutzer_id'] instanceof String)) {
      throw new Error("Expected the field `nutzer_id` to be a primitive type in the JSON string but got " + data['nutzer_id']);
    }
    return true;
  }
}
GlobalNotification.RequiredProperties = ["nutzer_id", "neuigkeiten_kfv", "neuigkeiten_kjf", "fortbildung_kfv", "fortbildung_kjf", "stellenanzeige", "id"];

/**
 * @member {String} nutzer_id
 */
GlobalNotification.prototype['nutzer_id'] = undefined;

/**
 * @member {Boolean} neuigkeiten_kfv
 */
GlobalNotification.prototype['neuigkeiten_kfv'] = undefined;

/**
 * @member {Boolean} neuigkeiten_kjf
 */
GlobalNotification.prototype['neuigkeiten_kjf'] = undefined;

/**
 * @member {Boolean} fortbildung_kfv
 */
GlobalNotification.prototype['fortbildung_kfv'] = undefined;

/**
 * @member {Boolean} fortbildung_kjf
 */
GlobalNotification.prototype['fortbildung_kjf'] = undefined;

/**
 * @member {Boolean} stellenanzeige
 */
GlobalNotification.prototype['stellenanzeige'] = undefined;

/**
 * @member {Number} id
 */
GlobalNotification.prototype['id'] = undefined;
var _default = exports.default = GlobalNotification;